/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { useLocales } from '../../locales';
import { PLATFORM_ICONS } from '../../config/icons';
import { LazyLoadImage } from 'react-lazy-load-image-component';
/* eslint-disable react/prop-types */
interface Props {
  post?: any | null;
}
// eslint-disable-next-line react/prop-types
const PostCard: React.FC<Props> = ({ post }) => {
  const { translate: t, currentLang } = useLocales();
  return (
    <div className="pb-3 listItem pe-10">
      <div className="card card-custom overlay min-h-200px mt-3 shadow">
        <div className="d-flex flex-column position-absolute me-n7 mt-2 ms-auto end-0 bg-white px-1 py-1 rounded">
          {Object.keys(post.analytics?.data_as_json?.published).map(
            (platform: any) => {
              if (platform?.published)
                return (
                  <span className="my-0">
                    <i
                      className={
                        PLATFORM_ICONS[
                          platform.platform as keyof typeof PLATFORM_ICONS
                        ]
                      }
                    ></i>
                  </span>
                );
              return null;
            }
          )}
        </div>

        <div className="card-body px-0 py-0 pb-2 my-0 d-flex flex-column justify-content-center align-items-center">
          <div className="w-100 overlay-wrapper">
            <a className="d-flex align-self-center h-100">
              <div className="position-absolute justify-content-center align-self-center w-100 loadingSpinner d-flex">
                <div className="d-flex align-items-center">
                  <div>
                    {post.is_video === true ? (
                      <i className="far fa-play-circle fs-4x text-light-primary"></i>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
              {post.preview_image_url !== null ? (
                <LazyLoadImage
                  className="card-img-top"
                  src={post.preview_image_url} // use normal <img> attributes as props
                  width={'100%'}
                />
              ) : (
                ''
              )}
            </a>
            {post.link_preview && !post.preview_image_url ? (
              <div className="w-100">
                <img className="w-100" src={post.link_preview.image} />
                <div className="w-100 d-flex flex-column bg-light-secondary px-5 py-5">
                  <div
                    className="text-uppercase mt-2 mb-1"
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {post.link_preview.domain}
                  </div>
                  <div
                    className="fw-bolder h4 mb-1"
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {post.link_preview.title}
                  </div>
                  <div
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis'
                    }}
                  >
                    {post.link_preview.description}
                  </div>
                </div>
              </div>
            ) : (
              ''
            )}

            <div className="overlay-layer align-items-start justify-content-end">
              <div className="d-flex flex-column flex-grow-1 justify-content-end bg-white-o-5 py-5 px-5">
                <div className="d-flex justify-content-end w-100 mb-4">
                  <a
                    href={post.analytics_ur}
                    className="btn fw-bold btn-sm btn-primary btn-shadow"
                  >
                    {t('analytics')}
                  </a>
                </div>

                <div className="d-flex justify-content-end w-100 mb-4">
                  <a
                    href={post.edit_url}
                    className="btn fw-bold btn-sm btn-warning btn-shadow"
                  >
                    {post.can_be_edited ? t('edit') : t('view')}
                  </a>
                </div>

                {post.can_be_deleted ? (
                  <div className="d-flex justify-content-end w-100">
                    <a
                      href={post.delete_url}
                      className="btn fw-bold btn-sm btn-danger btn-shadow"
                    >
                      {t('delete')}
                    </a>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          </div>
          <p
            className="px-2 text-dark mt-5 w-100"
            dangerouslySetInnerHTML={{ __html: post.preview_html }}
            style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
          ></p>
        </div>
        <div className="w-100 border-top p-3">
          <table className="table small mb-0 table-striped">
            <tbody>
              <tr>
                <td className="py-1">{t('last_edited_by')}:</td>
                <td className="py-1">
                  {post.last_editor !== null
                    ? post.last_editor
                    : t('external_user')}
                </td>
              </tr>

              <tr>
                <td className="py-1">{t('created_by')}:</td>
                <td className="py-1">{post.created_by}</td>
              </tr>

              <tr>
                <td className="py-1">{t('last_update')}:</td>
                <td className="py-1">
                  {' '}
                  {new Date(post.modified).toLocaleString(
                    currentLang.systemValue,
                    {
                      year: 'numeric',
                      month: 'short',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: 'numeric'
                    }
                  )}
                </td>
              </tr>

              {post.publication_date ? (
                <tr>
                  <td className="py-1">{t('publication_date')}:</td>
                  <td className="py-1">
                    {new Date(post.publication_date).toLocaleString(
                      currentLang.systemValue,
                      {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric'
                      }
                    )}
                  </td>
                </tr>
              ) : (
                ''
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PostCard;
